import { AppLayout } from '@src/components/sco/AppLayout'
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel'

import { OnboardingAside } from '@src/components/sco/Onboarding/Layout/OnboardingAside'
import { OnboardingContextProvider } from '@src/components/sco/Onboarding/Layout/OnboardingContext'
import { OnboardingNav } from '@src/components/sco/Onboarding/Layout/OnboardingNav'
import { SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'
import { HubspotHideChatStyles } from '@src/components/sco/utilities/HubspotChatHandler/HubspotHideChatStyles'
import { usePathname } from 'next/navigation'
import React, { useMemo } from 'react'

type OnboardingLayoutProps = {
  asidePanel?: React.ReactNode
  mainPanel?: React.ReactNode
  navPanel?: React.ReactNode
  navItems?: SidebarNestedNavListSection[]
  redirectUnauthenticated?: boolean
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = props => {
  const pathname = usePathname()
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState(false)
  const panels: AppLayoutPanelProps[] = useMemo(
    () => [
      {
        id: 'onboarding-nav',
        children: props.navPanel ? props.navPanel : <OnboardingNav />,
        defaultWidth: 240,
        isDrawerOpen: false,
        isPanelOpen: true,
        isResizable: true,
        maxWidth: 400,
        minWidth: 200,
        resizeHandlePosition: 'right',
        useDrawerBreakpoints: { base: true, md: false },
      },
      {
        id: 'onboarding-main',
        children: props.mainPanel,
        isPanelOpen: true,
        isDrawerOpen: true,
      },
      {
        id: 'onboarding-aside',
        children: props.asidePanel || <OnboardingAside />,
        defaultWidth: 460,
        drawerPlacement: 'right',
        isPanelOpen: asidePanelIsOpen,
        isResizable: true,
        maxWidth: 600,
        minWidth: 300,
        resizeHandlePosition: 'left',
        useDrawerBreakpoints: { base: true, lg: false },
        isDrawerOpen: false,
        onPanelClose: () => {
          setAsidePanelIsOpen(false)
        },
      },
    ],
    [pathname]
  )

  return (
    <OnboardingContextProvider
      navItems={props.navItems}
      redirectUnauthenticated={props.redirectUnauthenticated}
    >
      <AppLayout header={<ScoSiteNavBar />} id={'onboarding-layout'} panels={panels} />
      <HubspotHideChatStyles />
    </OnboardingContextProvider>
  )
}
